<template>
  <div>
    <div class="enter">
      <!-- 1.电力指数 -->
      <div class="right">
        <img
          style="height: 320px; width: 100%; overflow: hidden"
          src="../../assets/dlzsBgc.png"
          alt=""
        />
      </div>
    </div>
    <!-- 导航 -->
    <navigate :daohangshuju="daohangshuju" />
    <div class="text1 contentCss">
      <p>
        电力指数是通过庞大的电力征信数据库、科学的信用电力指数指标模型和自动评价系统，对电力集团及所属单位的信用建设情况实现线上实时全方位监测，并形成信用电力指数对信用体系建设情况进行衡量。<el-link
          type="primary"
          :underline="false"
          href="https://creditpower.cec.org.cn/creditIndex"
          target="_blank"
          ><span class="licxCss">立即查询>></span></el-link
        >
      </p>
    </div>
    <div class="product contentCss">
      <div class="text">
        <h4>信用体系建设状况的“晴雨表”</h4>
        <p>
          信用电力指数有利于推动企业信用指标横向对比，提高信用管理能力，防范化解信用风险，助力行业信用体系建设高质量发展。下一步，信用电力指数及系统监测研究工作将重点围绕扩大信用电力指数数据来源、优化信用电力指数指标模型、用好信用电力指数监测结果和进一步提升中电联信用服务能力等方面开展。通过信用电力指数，引导电力市场主体积极参与到信用体系建设中来，推动电力行业信用体系建设高质量发展。
        </p>
      </div>
      <div class="text">
        <h4>行业优势</h4>
        <p>
          在建立健全以信用为基础的新型监管机制过程中，中电联创新开展了“信用电力指数”研究。信用电力指数监测系统现已实现对上百家集团公司和其所属的近十万家下级企业进行信用监测。
        </p>
      </div>
      <div class="text">
        <h4>产品特色</h4>
        <p>
          信用电力指数运用柱状图谱形式展示各期信用电力指数行业标准值变化趋势，并可通过监测系统中的不同角色，是基于守信能力、守信表现、守信意愿，共3个一级指标、16
          个二级指标和48个三级指标建设的指数模型，将各集团信用建设情况进行量化计算，形成信用电力指数，并以“T+1”的频率更新行业排名。
        </p>
      </div>
      <div class="text">
        <h4>服务对象</h4>
        <p>电力集团及下属企业、电力行业上下游企业。</p>
      </div>
      <div class="text">
        <h4>服务价值</h4>
        <p>
          内部信用管理——依托中电联信用电力指数模型，支撑公司和各单位开展常态化信用风险自查。及时洞悉公司和各单位在电力行业、集团公司的指数排名情况，通报隐患，积极应对。
        </p>
        <p>
          外部信用监测——建设覆盖所属各单位和外部上下游利益相关企业的信用信息数据库，实现公司内外部利益相关方的信用信息归集共享和动态信用等级评价，提升相关企业监管和治理效能。
        </p>
      </div>
    </div>
    <!-- <div class="xdcSearch">
      <el-link type="primary" :underline="false" href="" target="_blank"
        >信电查入口</el-link
      >
    </div> -->
  </div>
</template>

<script>
import xdcPng from '@/assets/xdc.png'
import ckPng from '@/assets/logo.png'
import srcImg from '@/assets/xdc1.png'
import HoverImage from "@/components/HoverImage/index"
// 导航组件
import navigate from '@/components/navigate'
export default {
  name: 'vuecomponent',
  components: {
    HoverImage,
    navigate
  },
  data () {
    return {
      xdcPng: xdcPng,
      ckPng,
      searchInput: '',
      bannerList: [
        {
          id: 1,
          content: 'https://www.cecdlzx.com/oss/owms/26E5A26B9230CD01A4B1A1C44EC225BD/257f8ab88f9445b98f9c2826c3203e45.png',
          url: "https://www.cecdlzx.com/owms/#/home"
        },
        {
          id: 2,
          content: 'https://www.cecdlzx.com/oss/owms/26E5A26B9230CD01A4B1A1C44EC225BD/576e0a8c10f1459797aced9ca904efd1.png',
          url: "https://www.cecdlzx.com/dlzx/#/electric"
        },
        {
          id: 3,
          content: 'https://www.cecdlzx.com/oss/owms/26E5A26B9230CD01A4B1A1C44EC225BD/77b7d0be5ebc43ad94854b7863386d4c.png',
          url: "https://www.cecdlzx.com/dlzx/#/login"
        },
      ],
      key: "value",
      srcImg,
      daohangshuju: '电力指数',
    }
  }
}
</script>

<style lang="less" scoped>
.bannerImg {
  height: 260px;
}

.text1 {
  padding: 0 10px;
}
.product {
  margin-bottom: 60px;
  .h3Text {
    font-size: 24px;
    font-weight: 400;
    text-align: center;
    color: rgba(58, 58, 74, 1);
    margin-top: 30px;
  }
  .text {
    // margin: 15px;
    padding: 10px;
    h4 {
      color: #005ba3;
      margin-top: 10px;
      margin-bottom: 10px;
      font-size: 16px;
    }
    p {
      margin: 0 0 5px;
      line-height: 24px;
    }
  }
}

.partner {
  // margin: 10px 0;

  .title {
    text-align: center;
    position: relative;

    p {
      font-size: 48px;
      font-weight: bold;
      color: rgba(153, 154, 155, 0.3);
    }

    h2 {
      font-size: 36px;
      position: absolute;
      margin: 0;
      left: 45%;
      top: 35px;
    }
  }

  .list {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
    align-items: center;

    span {
      width: 150px;
      height: 60px;
    }
  }
}

.enter {
  overflow: hidden;
  position: relative;
  // padding: 10px;
  width: 100%;
  height: 350px;
  .right {
    width: 100%;
  }
  .last {
    margin-left: 80px;
    width: 100%;
    position: absolute;
    top: 260px;
    .smallBox {
      font-size: 16px;
      width: 180px;
      height: 50px;
      color: #fff;
      border-radius: 5px;
      padding: 10px;
      text-align: center;
      line-height: 45px;
      height: 60px;
      border: 2px solid #53aee7;
      background: #53aee7;
      box-shadow: 0 1px 1px #53aee7, 0 2px 2px #53aee7, 0 3px 3px #53aee7,
        0 4px 4px #53aee7, 0 5px 5px #53aee7;
      transform-origin: 50% 50%;
      /* 设置过渡动画 */
      transition: all 1s;
    }
  }
}
.smallBox:hover {
  /* 鼠标移动上去后  */
  transform: scale(1.2, 1.2);
}
.xdcSearch {
  margin: 10px auto;
  height: 45px;
  line-height: 45px;
  border-radius: 5px;
  text-align: center;
  border: 1px solid #53aee7;
  width: 150px;
}
</style>
